import React, { Component } from 'react';
import * as $ from 'jquery';
import Contact from './Contact.js';
import SuccessDialog from './SuccessDialog.js';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

export const SUBJECT = {
  SALES: "Ventas",
  SERVICE: "Servicio",
  BILLING: "Facturación"
};

let cancelToken;

class ContactContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState(props);
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.setModalListener();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  contact = (params) => {
    this.props.post(
      "/contact",
      params,
      () => this.didContact(),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didContact = () => {
    $('#btnSuccess').click();
  }

  getInitState = (props) => {
    const user = props.user;
    const name = user.name + " " + user.lastname;

    return {
      email: user.contactEmail,
      message: "",
      company: user.company,
      name: name,
      phone: user.phone,
      subject: "",
      toDashboard: false
    };
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.contact({
      name: this.state.name,
      company: this.state.company,
      email: this.state.email,
      message: this.state.message,
      phone: this.state.phone,
      subject: this.state.subject,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleMessageChange = (event) => {
    this.setState({ message: event.target.value });
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  }

  handlePhoneChange = (event) => {
    this.setState({ phone: event.target.value });
  }

  handleCompanyChange = (event) => {
    this.setState({ company: event.target.value });
  }

  handleSubjectChange = (event) => {
    this.setState({ subject: event.target.value });
  }

  setModalListener = () => {
    $('#modalSuccess').on('hidden.bs.modal', () => {
      this.setState({ toDashboard: true });
    });
  }

  renderContact = () => {
    return (
      <Contact
        email={this.state.email}
        handleEmailChange={this.handleEmailChange}
        handleFormSubmit={this.handleFormSubmit}
        handleMessageChange={this.handleMessageChange}
        handleNameChange={this.handleNameChange}
        handleCompanyChange={this.handleCompanyChange}
        handlePhoneChange={this.handlePhoneChange}
        handleSubjectChange={this.handleSubjectChange}
        message={this.state.message}
        name={this.state.name}
        company={this.state.company}
        phone={this.state.phone}
        subject={this.state.subject} />
    );
  }

  renderSuccessDialog = () => {
    return (
      <SuccessDialog />
    );
  }

  render() {
    if (this.state.toDashboard) {
      return <Redirect to="/marketplace" />;
    }

    const { t } = this.props;
    return (
      <div>
        <h2 className="page-header">{t('dashboard.contact.heading')}</h2>
        {this.renderContact()}
        {this.renderSuccessDialog()}
      </div>
    );
  }
}

export default translate('common')(ContactContainer);



// WEBPACK FOOTER //
// ./src/dashboard/contact/ContactContainer.js